


































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import Logo from './Logo.vue'
import { getOrganizeType } from '@/utils/cookies'

  @Component({
    name: 'Navbar',
    components: {
      Logo
    }
  })
export default class extends Vue {
  get userInfo() {
    return UserModule.userInfo
  }
  get campusId() {
    return UserModule.campusId
  }
  get oCampus() {
    return UserModule.campus
  }
  get stayList() {
    return UserModule.stayList
  }
  private async handleCommand(data: { id: number }) {
    if (this.campusId !== data.id) {
      await UserModule.SetCurrentCampus(data)
      // this.$router.push(`/`)
      // window.location.reload()
      // await this.$store.dispatch('getUnhandlerList')
      await setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname
      })
    }
  }
  private async logout() {
    const organizeType = getOrganizeType()
    if (organizeType === 101) {
      await UserModule.LogOut()
    } else if (organizeType === 102) {
      await UserModule.OrganizeLogOut()
    }
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    this.$router.push(`/login`)
    location.reload()
  }
  private navigator() {
    !(this.$route.path === '/motion/motionSchedule/arrangeStudent/list') && this.$router.push('/motion/motionSchedule/arrangeStudent/list')
  }
}
